import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userReducer";

const rootReducer = combineReducers({
    //add all your reducers here
    user: userReducer
},);


export const store = configureStore({
    reducer: rootReducer,
});
